import { Component, Inject, Input } from '@angular/core';
import { APP_CONFIG } from '../../api/config';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { User } from '../../api/model/user/user.model';

@Component({
  selector: 'points-description',
  templateUrl: './points-description.component.html',
  styleUrls: ['./points-description.component.scss']
})
export class PointsDescriptionComponent {
  tableCollapse: boolean;
  user: User;
  @Input() messages;

  constructor(@Inject(APP_CONFIG) protected appConfig: IAppConfig) {
    this.tableCollapse = true;
  }

  @Input()
  set member(member: User) {
    if (member) {
      this.user = member;
    }
  }

  toggleCollapse() {
    this.tableCollapse = !this.tableCollapse;
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/points-description/points-description.component.ts